import {
  FETCH_RAMPS,
  FETCH_RAMPS_SUCCESS,
  FETCH_RAMPS_FAILED,
  FETCH_ASSIGNMENTS,
  FETCH_ASSIGNMENTS_SUCCESS,
  FETCH_ASSIGNMENTS_FAILED,
  APPLY_ASSIGNMENT,
  APPLY_ASSIGNMENT_SUCCESS,
  APPLY_ASSIGNMENT_FAILED,
  DELETE_ASSIGNMENT,
  DELETE_ASSIGNMENT_SUCCESS,
  DELETE_ASSIGNMENT_FAILED,
} from './ramps-actions';

export const RAMPS_STATE_KEY = 'rampsState';

const initialState = {
  ramps: [] as any[],
  loading: false,
  error: null as any,
  assignments: [] as any[],
  assignmentsTotal: 0,
  assignmentsPages: 0,
  assignmentsLoading: false,
  assignmentsError: null as any,
  applyLoading: false,
  applyError: null as any,
  deleteLoading: false,
  deleteError: null as any,
  assignmentModal: null as any,
};

export const rampsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_RAMPS:
      return { ...state, loading: true, error: null };
    case FETCH_RAMPS_SUCCESS:
      return { ...state, loading: false, ramps: action.payload || [] };
    case FETCH_RAMPS_FAILED:
      return { ...state, loading: false, error: action.payload };
    case FETCH_ASSIGNMENTS:
      return { ...state, assignmentsLoading: true, assignmentsError: null };
    case FETCH_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        assignmentsLoading: false,
        assignments: (action.payload && action.payload.contents) || [],
        assignmentsTotal: (action.payload && action.payload.total) || 0,
        assignmentsPages: (action.payload && action.payload.pages) || 0,
      };
    case FETCH_ASSIGNMENTS_FAILED:
      return { ...state, assignmentsLoading: false, assignmentsError: action.payload };
    case 'OPEN_ASSIGNMENT_MODAL':
      return { ...state, assignmentModal: action.payload };
    case APPLY_ASSIGNMENT:
      return { ...state, applyLoading: true, applyError: null };
    case APPLY_ASSIGNMENT_SUCCESS:
      return { ...state, applyLoading: false };
    case APPLY_ASSIGNMENT_FAILED:
      return { ...state, applyLoading: false, applyError: action.payload };
    case DELETE_ASSIGNMENT:
      return { ...state, deleteLoading: true, deleteError: null };
    case DELETE_ASSIGNMENT_SUCCESS:
      return { ...state, deleteLoading: false };
    case DELETE_ASSIGNMENT_FAILED:
      return { ...state, deleteLoading: false, deleteError: action.payload };
    case 'CLEAR_ASSIGNMENT_MODAL':
      return { ...state, assignmentModal: null };
    default:
      return state;
  }
};

export default rampsReducer;
